import React from "react";
import { useRecoilValue } from "recoil";
import { isMobileSelector } from "../../recoil/selectors";
import styles from "./Banner.module.scss";
import { configBall } from "../../lib/ball/config";
import "aos/dist/aos.css";

const Ball = () => {
  const mobile = useRecoilValue(isMobileSelector);

  if (window.BlobAnimation) {
    new window.BlobAnimation("ball", configBall(mobile ? 150 : 400));
  }

  return <div id="ball" className={styles.Ball} />;
};

export default Ball;
